//! Narrow-viewport disclosure for the right-edge coverage sliders.
//!
//! Below 62rem the Minimum signal, Receiver height, and Opacity cards are hidden
//! behind a compact "Coverage controls" button so they wrap instead of clipping
//! off the map. Desktop always shows them, so the disclosure only tracks its own
//! expanded attribute; each slider still owns its own visibility.

/** Toggles the compact coverage controls panel and keeps the button's ARIA state truthful. */
export class CoverageSlidersDisclosure {
  private readonly root: HTMLElement | null;
  private readonly toggle: HTMLButtonElement | null;

  public constructor(root: ParentNode) {
    this.root = root.querySelector<HTMLElement>("[data-coverage-sliders]");
    this.toggle = root.querySelector<HTMLButtonElement>("[data-coverage-sliders-toggle]");
  }

  /** Wires the disclosure button and starts from the collapsed state. */
  public connect(): void {
    this.toggle?.addEventListener("click", this.handleToggleClick);
    this.setExpanded(false);
  }

  /** Removes the disclosure listener. */
  public disconnect(): void {
    this.toggle?.removeEventListener("click", this.handleToggleClick);
  }

  private readonly handleToggleClick = (): void => {
    this.setExpanded(this.root?.dataset.coverageSlidersExpanded !== "true");
  };

  private setExpanded(expanded: boolean): void {
    if (this.root !== null) {
      this.root.dataset.coverageSlidersExpanded = String(expanded);
    }
    this.toggle?.setAttribute("aria-expanded", String(expanded));
  }
}
